import { compose } from '@bem-react/core';
import cx from 'classnames';
import React, { ReactNode, RefObject } from 'react';

import { IWithOutsideClickProps, withOutsideClick } from '../../../utils/hocs/withOutsideClick';
import { withPopupViewRegular } from '../../ui/Popup/_view/Popup_view_regular';
import { Direction, PopupBase, withTargetAnchor, withZIndex } from '../../ui/Popup/Popup';

const Popup = compose(withOutsideClick, withZIndex, withTargetAnchor, withPopupViewRegular)(PopupBase);

export type ImagesPopupDirection = Direction;

export type OnImagesPopupClose = (event: KeyboardEvent | MouseEvent, source: 'esc' | 'click') => void;

export interface ImagesPopupProps {
    anchorRef: RefObject<HTMLElement>;
    children?: ReactNode;
    directions?: ImagesPopupDirection[];
    mainOffset?: number;
    scopeRef?: RefObject<HTMLElement>;
    onClose?: OnImagesPopupClose;
    visible: boolean;
    mix?: string;
}

export const ImagesPopup = (props: ImagesPopupProps & IWithOutsideClickProps) => {
    const { anchorRef, children, directions, mainOffset, scopeRef, visible, onClose, mix } = props;

    return (
        <Popup
            anchor={anchorRef}
            className={cx('images-menu__popup', mix)}
            direction={directions}
            ignoreRefs={[anchorRef]}
            mainOffset={mainOffset}
            onClose={onClose}
            scope={scopeRef}
            target={'anchor'}
            view={'regular'}
            visible={visible}
        >
            {children}
        </Popup>
    );
};
